<div class="rdb-wrap">
    <div class="rdb-table-container">
        <table class="rdb-table">
            <thead>
                <tr>
                    <th>Pricing Plan</th>
                    <th>Transition Type</th>
                    <th>Status</th>
                    <th>Overage (KM)</th>
                    <th>Starting Fee Charge</th>
                    @if (hasOperationalCharge) {
                    <th>Operational Charge</th>
                    }
                    <th>Plan Charge</th>
                    <th>Mileage Package</th>
                    <th>Excess KMs Charge</th>
                    <th>Grace Charge</th>
                    <th>Group Name</th>
                    <th>Group Discount</th>
                    <th>End Type</th>
                    <th>Started At</th>
                    <th>Ended At</th>
                    <th>Plan Expires At</th>
                    <th>Grace Period Expires At</th>
                </tr>
            </thead>
            <tbody>
                @for (row of pagedBillings; track $index) {
                <tr>
                    <td>{{ row.pricingPlanName || '---' }}</td>
                    <td>{{ row.transitionType.split('_').join(' ') | capitalize }}</td>
                    <td>{{ row.status | capitalize }}</td>
                    <td>{{ row.overageKm || '---' }}</td>
                    <td>{{ row.startingFeeCharge || '---' }}</td>
                    @if (hasOperationalCharge) {
                    <td>{{ row.operationalCharge ?? '---' }}</td>
                    }
                    <td>{{ row.planCharge || '---' }}</td>
                    <td>{{ row.mileageCharge || '---' }}</td>
                    <td>{{ row.overageCharge || '---' }}</td>
                    <td>{{ row.graceCharge || '---' }}</td>
                    <td>{{ row.customerGroupName || '---' }}</td>
                    <td>{{ row.groupDiscountPercentage !== null && row.groupDiscountPercentage !== undefined ? (row.groupDiscountPercentage + '%') : '---' }}</td>
                    <td>{{  row.endType && row.endType.split('_').join(' ') | capitalize }}</td>
                    <td>
                        <span class="rdb-date-main">{{ (row.startedAt | date:'MM/dd/yyyy') || '---' }}</span>
                        <span class="rdb-date-sub">{{ row.startedAt | date:'hh:mm:ss a' }}</span>
                    </td>
                    <td>
                        <span class="rdb-date-main">{{ (row.endedAt | date:'MM/dd/yyyy') || '---' }}</span>
                        <span class="rdb-date-sub">{{ row.endedAt | date:'hh:mm:ss a' }}</span>
                    </td>
                    <td>
                        <span class="rdb-date-main">{{ (row.planExpiresAt | date:'MM/dd/yyyy') || '---' }}</span>
                        <span class="rdb-date-sub">{{ row.planExpiresAt | date:'hh:mm:ss a' }}</span>
                    </td>
                    <td>
                        <span class="rdb-date-main">{{ (row.gracePeriodExpiresAt | date:'MM/dd/yyyy') || '---' }}</span>
                        <span class="rdb-date-sub">{{ row.gracePeriodExpiresAt | date:'hh:mm:ss a' }}</span>
                    </td>
                </tr>
                } @empty {
                <tr>
                    <td [attr.colspan]="hasOperationalCharge ? 17 : 16" class="rdb-empty">No billing records found</td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    @if (totalRecords > 0) {
    <div class="table-footer">
        <span class="footer-count">Showing {{ first + pagedBillings.length }} of {{ totalRecords }}</span>
        <p-paginator [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[20, 30, 50]"
            [dropdownAppendTo]="'body'" (onPageChange)="onPageChange($event)" />
    </div>
    }
</div>